import uuidv4 from 'uuid/v4';
import { IdProvider } from '../provider';

export interface CreateLocalStorageIdProviderOptions {
  namespace: string;
}

export const createLocalStorageIdProvider = (config: CreateLocalStorageIdProviderOptions): IdProvider => {
  const namespace = config.namespace;

  const existingValue = localStorage.getItem(namespace);

  return {
    get(): Promise<string> {
      if (existingValue) return Promise.resolve(existingValue);

      const newId = `local-${uuidv4()}`;
      localStorage.setItem(namespace, newId);
      return Promise.resolve(newId);
    },
  };
};
